import axios from '../../../shared/utils/axios';
import { addToast } from '../toasts/toastsActions';
import { toastTypes } from '../../../shared/components/Toast/ToastOptions';
import { actionSuccess } from '../utils';

export const FETCH_SUBSIDIARIES = 'FETCH_SUBSIDIARIES';

const fetchSubsidiariesEndpoint = `${process.env.REACT_APP_API_URL}dashboards/company/subsidiaries`;

export const fetchSubsidiaries = () => async dispatch => {
  try {
    const response = await axios.get(fetchSubsidiariesEndpoint);
    dispatch(actionSuccess(FETCH_SUBSIDIARIES, response.data.data));

    return response.data;
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};
